import { render, staticRenderFns } from "./riskdegerlendirmeverigirisdurum.vue?vue&type=template&id=57d28d63"
import script from "./riskdegerlendirmeverigirisdurum.vue?vue&type=script&lang=js"
export * from "./riskdegerlendirmeverigirisdurum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports